import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { reportEvent } from '@/utils/track'
import { navItems } from '@/components/menu-pro/data'

const WHITE_LIST = ['/visit-charts']

const getPathName = (path: string) => {
  const item = navItems.find(item => item.link === path)
  return item?.label || path
}

export function usePageTracking() {
  const location = useLocation()
  const lastPathRef = useRef<string>()

  useEffect(() => {
    const path = location.pathname + location.search
    if (lastPathRef.current === path || WHITE_LIST.includes(location.pathname)) return
    lastPathRef.current = path
    const pathName = getPathName(location.pathname)
    reportEvent(path, pathName)
  }, [location])
}
